
















import { ref, computed, defineComponent, onMounted } from '@vue/composition-api';
import QaTips from './qa-tips.vue';

export default defineComponent({
    name: "module-title", // ICP备案主页面
    components: {
        QaTips

    },
    props: {
        title: {
            type: String,
            default: ''
        },
        tips: {
            type: String,
            default: ''
        },
        subText: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: 'normal'
        }
    },
    setup(props, context) {

        onMounted(() => {

        })
        return {

        }
    },
})
